import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import LicService from '../../../../../services/licitacao-auth';
import Moment from 'moment';

const Licitacao = () => {
    let { id } = useParams();
    const [objeto, setObjeto] = useState("");
    const [processo, setProcesso] = useState("");
    const [licitacao, setLicitacao] = useState("");
    const [ano, setAno] = useState("");
    const [valor, setValor] = useState("");
    const [leiBeneficio, setLeiBeneficio] = useState("");
    const [modalidade, setModalidade] = useState("");
    const [situacao, setSituacao] = useState("");
    const [observacao, setObservacao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [dataLic, setDataLic] = useState("");
    const [hora, setHora] = useState("");
    const [orgaoSRP, setOrgaoSRP] = useState("");
    const [sit, setSit] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false)

    async function fetchLic(id) {
        const response = await LicService.licEdit(id);
        Moment.locale();
        defineSituacao(response.data["situacao"]);
        setObjeto(response.data["objeto"]);
        setProcesso(response.data["processo"]);
        setLicitacao(response.data["licitacao"]);
        setDataLic(Moment(response.data["dataLic"]).utc(false).format("yyyy-MM-DD"));
        setDataPub(Moment(response.data["dataPub"]).utc(false).format("yyyy-MM-DD"));
        setAno(response.data["ano"]);
        setValor(response.data["valor"]);
        setLeiBeneficio(response.data["leiBeneficio"]);
        setModalidade(response.data["modalidade"]);
        setSituacao(response.data["situacao"]);
        setObservacao(response.data["observacao"]);
        setHora(response.data["hora"]);
        setOrgaoSRP(response.data["orgaoSRP"]);
    }

    const defineSituacao = (situacao) => {
        switch (situacao) {
            case "Em Andamento":
                setSit("andamento")
                break;
            case "Publicada":
                setSit("avisos")
                break;
            case "Homologada":
            case "Cancelada":
                setSit("encerradas")
                break;
            default:
                setSit("todas")
                break;
        }
    }

    useEffect(() => {
        fetchLic(id)
    }, [id])



    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const lic = await LicService.editar(id, {
                objeto: objeto,
                processo: processo,
                licitacao: licitacao,
                ano: ano,
                valor: valor,
                leiBeneficio: leiBeneficio,
                modalidade: modalidade,
                situacao: situacao,
                observacao: observacao,
                dataPub: dataPub,
                dataLic: dataLic,
                orgaoSRP: orgaoSRP,
                hora: hora
            })
            if (lic.data["cod_lic"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado na edição!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const ponto = (campo) => {
        return campo.replace(/,/g, ".");
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="Objeto">
                                <FloatingLabel
                                    label="Objeto"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="textarea"
                                        name="objeto"
                                        value={objeto}
                                        onChange={e => setObjeto(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="processo">
                                <FloatingLabel
                                    label="Processo"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="processo"
                                        value={processo}
                                        onChange={e => setProcesso(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Licitação">
                                <FloatingLabel
                                    label="Licitação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        name="licitacao"
                                        value={licitacao}
                                        onChange={e => setLicitacao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Valor da Licitação">
                                <FloatingLabel
                                    label="Valor da Licitação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="valor"
                                        value={valor}
                                        onChange={e => setValor(ponto(e.target.value))} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Modalidade">
                                <FloatingLabel
                                    label="Modalidade"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Modalidade"
                                        name="modalidade"
                                        onChange={e => setModalidade(e.target.value)}
                                    >
                                        <option value={modalidade}>{modalidade}</option>
                                        <option value="Carta Convite">Carta Convite</option>
                                        <option value="Concorrência">Concorrência</option>
                                        <option value="Chamamento Público para Credenciamento em Saúde">Chamamento Público para Credenciamento em Saúde</option>
                                        <option value="Concurso">Concurso</option>
                                        <option value="Leilão">Leilão</option>
                                        <option value="Pregão">Pregão</option>
                                        <option value="Pregão Eletrônico">Pregão Eletrônico</option>
                                        <option value="Ata de Adesão - SRP">Ata de Adesão - SRP</option>
                                        <option value="Tomada de Preço">Tomada de Preço</option>
                                        <option value="Dispensa">Dispensa</option>
                                        <option value="Inexigibilidade">Inexigibilidade</option>
                                        <option value="COVID">COVID</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value={situacao}>{situacao}</option>
                                        <option value="Publicada">Publicada</option>
                                        <option value="Em Andamento">Em Andamento</option>
                                        <option value="Homologada">Homologada</option>
                                        <option value="Cancelada">Cancelada</option>
                                        <option value="Deserta">Deserta</option>
                                        <option value="Suspensa">Suspensa</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Benefício Lei 123">
                                <FloatingLabel
                                    label="Benefício Lei 123"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Benefício Lei 123"
                                        name="leiBeneficio"
                                        onChange={e => setLeiBeneficio(e.target.value)}
                                    >
                                        <option value={leiBeneficio}>{leiBeneficio}</option>
                                        <option value="Ampla Concorrência">Ampla Concorrência</option>
                                        <option value="Exclusivo para MEI/ME e EPP">Exclusivo para MEI/ME e EPP</option>
                                        <option value="Exigência Subcontratação ME">Exigência Subcontratação ME</option>
                                        <option value="Com Itens Exclusivos">Com Itens Exclusivos</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        {modalidade === "Ata de Adesão - SRP" ?
                            <Col xs={12} lg={12}>
                                <Form.Group className="mb-3" controlId="Orgão SRP">
                                    <FloatingLabel
                                        label="Órgão Gerenciador"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="text"
                                            name="orgaoSRP"
                                            value={orgaoSRP}
                                            onChange={e => setOrgaoSRP(e.target.value)} />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col> : null}
                        <Col xs={12} lg={6}>
                            <Form.Group className="mb-3" controlId="Observação">
                                <FloatingLabel
                                    label="Observação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="textarea"
                                        name="observacao"
                                        value={observacao}
                                        onChange={e => setObservacao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="DataPub">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataPub"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="DataLic">
                                <FloatingLabel
                                    label="Data da Licitação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataLic"
                                        value={dataLic}
                                        onChange={e => setDataLic(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="Hora">
                                <FloatingLabel
                                    label="Hora"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        aria-label="Hora"
                                        name="hora"
                                        onChange={e => setHora(e.target.value)}
                                    >
                                        <option value={hora}>{hora}</option>
                                        <option value="9h">9H</option>
                                        <option value="10h">10H</option>
                                        <option value="11h">11H</option>
                                        <option value="12h">12H</option>
                                        <option value="13h">13H</option>
                                        <option value="14h">14H</option>
                                        <option value="15h">15H</option>
                                        <option value="16h">16H</option>
                                        <option value="17h">17H</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={`/restrito/licitacao/listar/${sit}`}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Licitação atualizada com sucesso!</Alert>
                <Link to={'/restrito/licitacao/listar/andamento'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Licitações em Andamento
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/licitacao/listar/encerradas'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Licitações Encerradas
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/licitacao'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Licitacao;